import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import DashboardSimpleNumber, {
  tooltipModuleList,
} from "features/Dashboards/Base/DashboardSimpleNumber";
import Badge from "components/Badge";
import { buildingDashboardStore } from "store/Building/BuildingDashboardStore";
import { GWP_M2_AREA_UNIT } from "utils";
import NotAvailableChip from "./NotAvailableChip";

/** Sums the "D" module trace (module-D credit is reported separately). */
function moduleDCredit(): number | null {
  const trace = buildingDashboardStore.emissionsInfo?.gwp_traces?.find(
    (t) => (t.name ?? "").trim().toUpperCase() === "D"
  );
  return trace && Array.isArray(trace.y)
    ? trace.y.reduce((sum: number, point) => sum + (Number(point) || 0), 0)
    : null;
}

export default observer(function GwpTopMetrics() {
  const { t } = useTranslation();
  const info = buildingDashboardStore.emissionsInfo;

  const total = info?.grand_total ?? null;
  const moduleD = moduleDCredit();

  return (
    <div className="grid grid-cols-3 gap-4 mb-5">
      <div className="rounded-lg bg-gray-100 p-5 flex flex-col justify-center">
        <DashboardSimpleNumber
          title={t("levels.totalACB6")}
          value={total}
          unit={GWP_M2_AREA_UNIT}
          tooltip={tooltipModuleList(t, undefined, info?.all_modules)}
        />
      </div>
      {/* Benchmark — the backend has no Level(s) benchmark value yet. */}
      <div className="rounded-lg bg-gray-100 p-5 flex flex-col justify-center items-center text-center gap-2">
        <h3 className="text-md text-gray-500">{t("levels.benchmark")}</h3>
        <Badge type="info" size="small">
          {t("levels.comingSoon")}
        </Badge>
      </div>
      <div className="rounded-lg bg-gray-100 p-5 flex flex-col justify-center items-center text-center gap-2">
        {moduleD != null ? (
          <DashboardSimpleNumber
            title={t("levels.moduleDCredit")}
            value={moduleD}
            unit={GWP_M2_AREA_UNIT}
          />
        ) : (
          <>
            <h3 className="text-md text-gray-500">
              {t("levels.moduleDCredit")}
            </h3>
            <NotAvailableChip />
          </>
        )}
      </div>
    </div>
  );
});
